import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultButton, Modal, PrimaryButton, Dropdown } from '@fluentui/react';
import { Selection } from '@fluentui/react/lib/DetailsList';
import * as Api from '../../../api/src';
import ModalHeader from '../../../control/modalHeader';
import Moment from 'moment';

const MatrixItemsApi = new Api.MatrixItemsApi();
const UserApi = new Api.UserApi();

export interface ModalAddUserProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  onSaveClick: () => void;
  Item: number | null;
}
const ModalAddUser = ({ IsOpen, onCloseModal, onSaveClick, Item }: ModalAddUserProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);
  const [listModules, setListModules] = React.useState<Api.Module[]>([]);
  const [listUsers, setlistUsers] = React.useState<any[]>([]);
  const [listSelected, setListSelected] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (IsOpen && Item) {
      SetIsShow(IsOpen);
      getDetai();
      getAllUsers();
    }
  }, [IsOpen]);

  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const onSave = async () => {
    await MatrixItemsApi.apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut(Item || 0, listSelected);
    onCloseModal();
    SetIsShow(false);
    onSaveClick();
  };

  const getDetai = async () => {
    const data = (await MatrixItemsApi.apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet(Item || 0)).data.Data;
    setListModules(data?.Modules || []);
    /* let users: any[] = [{ key: null, text: t("None") }];
        data?.Users?.forEach(element => {
            users.push({ key: element.Id, text: element.FullName });
        });
        setlistUsers(users); */
    let selected: any[] = [];
    data?.ModuleUserReponsives?.forEach((element, idx) => {
      if (data?.Modules) {
        selected.push({
          ModuleId: element.ModuleId,
          Name: data?.Modules[idx].Name,
          ReponsiveUserId: element.ReponsiveUserId,
        });
      }
    });
    setListSelected(selected);
  };

  const getAllUsers = async () => {
    let data = (await MatrixItemsApi.apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet(Item || 0)).data;
    let users: any[] = [{ key: null, text: t('None') }];
    data.Data?.forEach((element) => {
      users.push({ key: element.Id, text: element.FullName + ' (' + element.Company + ')' });
    });
    setlistUsers(users);
  };
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={t('ResponsiveStep')}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700 }}>
        <div className="ms-Grid" dir="ltr">
          <div style={{ color: 'rgb(161, 159, 157)', marginBottom: 16 }}>{t('ResponsiveText')}</div>
          {listSelected.map((item, idx) => {
            return (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6" style={{ paddingTop: 12 }}>
                  {item.Name}
                </div>
                <div className="label ms-Grid-col ms-sm6">
                  <Dropdown
                    options={listUsers}
                    selectedKey={item.ReponsiveUserId}
                    placeholder={t('SelectUser')}
                    onChange={(e, newValue) => {
                      if (newValue) {
                        item.ReponsiveUserId = newValue.key;
                        setListSelected([...listSelected]);
                      }
                    }}
                  ></Dropdown>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          className={'margin-left-10'}
          onClick={() => {
            onClose();
          }}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModalAddUser;
